import { Button } from '@castlery/fortress';
import { stripeUtil } from '@castlery/utils';

export const StripeCancelButton = () => {
  const onCancel = async () => {
    await stripeUtil.cancelCollectPaymentMethod();
    await stripeUtil.cancelCollectSetupIntentPaymentMethod();
  };
  return (
    <>
      <Button variant="secondary" color="neutral" size="lg" onClick={onCancel}>
        Cancel
      </Button>
    </>
  );
};

export default StripeCancelButton;
